import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";

export default function ManagerHistory() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data));
  }, []);

  return (
    <div>
      <PageHeader testId="manager-history" title="Historia zamówień" subtitle="Wszystkie zamówienia z Twoich budów" />
      <div className="ol-card overflow-hidden">
        {orders.length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-500">Brak zamówień.</div>
        ) : (
          <table className="ol-table" data-testid="manager-history-table">
            <thead>
              <tr><th>Numer</th><th>Budowa</th><th>Pracownik</th><th>Data</th><th className="text-right">Wartość</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td className="font-mono text-xs">{o.order_number}</td>
                  <td className="text-slate-700">{o.site_name}</td>
                  <td className="text-slate-600">{o.created_by_name}</td>
                  <td className="text-slate-600">{formatDate(o.created_at)}</td>
                  <td className="text-right font-semibold">{formatPLN(o.final_total_net)}</td>
                  <td><StatusBadge status={o.status} /></td>
                  <td><Link to={`/orders/${o.id}`} className="ol-link text-xs">Szczegóły</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
